export { default as InjectedTool } from "./InjectedTool.vue";
export { default as PageListTool } from "./PageListTool.vue";
export { default as AlertTool } from "./AlertTool.vue";
export { default as CommentTool } from "./CommentTool.vue";
export { default as BookmarkTool } from "./BookmarkTool.vue";
export { default as DocumentViewTool } from "./DocumentViewTool.vue";
export { default as AlertList } from "./AlertList.vue";
export { default as AiPhraseTool } from "./AiPhraseTool.vue";
export * from "./ITabDefinition";
